import React from "react";

const TableLoading = ({ header }) => {
  let numberArr = [];

  for (let i = 0; i < header?.length; i++) {
    numberArr.push(i);
  }

  return (
    <table className="w-full border-separate border-spacing-2">
      <thead className="text-xs capitalize text-left">
        <tr>
          {header.map((th) => (
            <th key={th} scope="col" className="font-normal text-xs">
              {th}
            </th>
          ))}
        </tr>
      </thead>
      <tbody className="text-xs capitalize text-left">
        {[1, 2, 3, 4].map((tr) => (
          <tr key={tr} className="row space-x-3">
            {numberArr.map((td) => (
              <td
                key={td}
                className="font-normal text-xs px-2 py-3.5 bg-white rounded-md animate-pulse"
              ></td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default TableLoading;
